module.exports = __webpack_public_path__ + "static/media/V_pictos-08.f4ea443d.svg";